<template>
  <div>
    <!-- 更换手机验证 -->
    <el-dialog title="修改手机号" width="398px" :visible.sync="updateShow" @close="cancel" destroy-on-close :close-on-click-modal="false" :modal-append-to-body="false" class="bindPhoneDialog">
<!--      <section class="dialogContent">-->
<!--        <p class="hint" v-show="checkWay">-->
<!--          使用手机验证身份，解绑后将无法使用该手机号登录此账号，现在手机：<span class="blue">{{phone | addStar}}</span>-->
<!--        </p>-->
<!--        <p class="hint" v-show="!checkWay">-->
<!--          使用邮箱验证身份，解绑后将无法使用该手机号登录此账号，现在邮箱：<span class="blue">{{mail | addStar('mail')}}</span>-->
<!--        </p>-->
<!--        <el-form :model="updatePhoneForm" :rules="phoneRules" ref="checkPhone">-->
<!--          <el-form-item prop="captcha">-->
<!--            <el-input v-model="updatePhoneForm.captcha" maxlength="6" placeholder="请输入验证码">-->
<!--              <el-button slot="suffix" @click="sendSMS(5)" type="text" class="inputSuffix" :loading="timeRemaining==60&&!allow" :disabled="!allow">{{timeRemaining==60?'获取验证码':'重新获取'+timeRemaining}}</el-button>-->
<!--            </el-input>-->
<!--          </el-form-item>-->
<!--          <el-button type="text" v-if="mail" class="clearMargenPadding" @click="switchCheckWay">{{checkWay?'通过邮箱验证':'通过手机验证'}}</el-button>-->
<!--        </el-form>-->
<!--      </section>-->

      <section class="new_dialogContent">
        <Tabs :tabs="tabs" :margin="17" @change="changeTabs" :defaultShow="false" ref="TabsCom"/>
        <div class="new_dialogContent_from">
          <div class="phoneORmail" v-show="tabsVal !== 1">
            <p class="new_dialogContent_from_label">{{ labelObj[tabsVal] }}</p>
            <div class="phoneORmail_val" v-if="tabsVal === 0">{{ userInfo[str[tabsVal]] | addStar }}</div>
            <div class="phoneORmail_val" v-if="tabsVal === 2">{{ userInfo[str[tabsVal]] | addStar('mail') }}</div>
            <p class="new_dialogContent_from_label">验证码</p>
            <el-form :model="updatePhoneForm" :rules="phoneRules" ref="checkPhone" class="new_dialogContent_from_el_form">
              <el-form-item prop="captcha">
                <el-input
                  v-model="updatePhoneForm.captcha"
                  maxlength="6"
                  :placeholder="'请输入' + (tabsVal === 0 ? '手机' : '邮箱') + '验证码'">
                  <el-button
                    slot="suffix"
                    @click="sendSMS(5)"
                    type="text"
                    class="inputSuffix"
                    :loading="timeRemaining == 60 && !allow"
                    :disabled="!allow"
                  >{{ timeRemaining == 60 ? '获取验证码' : '重新获取' + timeRemaining }}</el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="Password" v-show="tabsVal === 1">
            <p class="new_dialogContent_from_label">当前密码</p>
            <el-form :model="updatePhoneForm" :rules="phoneRules" ref="Password_from" class="new_dialogContent_from_el_form">
              <el-form-item prop="Password">
                <el-input
                  v-model="updatePhoneForm.Password"
                  show-password
                  placeholder="请输入当前密码">
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button size="medium" type="primary" @click="checkPhone" :loading="disableNext">下一步</el-button>
      </div>
    </el-dialog>
    <!-- 修改/绑定手机号 -->
    <el-dialog :title=" userInfo.phone ? '修改手机号' : '绑定手机'" width="398px" :visible.sync="bindShow" @close="cancel" :close-on-click-modal="false" destroy-on-close>
      <section class="dialogContent">
        <el-form :model="bindPhoneForm" :rules="phoneRules" ref="bindPhone" :hide-required-asterisk="true">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="bindPhoneForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="captcha">
            <el-input v-model="bindPhoneForm.captcha" maxlength="6" placeholder="请输入验证码">
              <el-button slot="suffix" @click="sendSMS(2)" type="text" class="inputSuffix" :loading="timeRemaining==60&&!allow" :disabled="!allow">{{timeRemaining==60?'获取验证码':'重新获取'+timeRemaining}}</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button size="medium" type="primary" @click="changePhoneSub" :loading="subLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { checkPhone, updatePhone, bindPhone } from "../../../api/accountManage"
import { mapGetters, mapActions } from "vuex";
import { phoneVerify } from "../../../tool";
import Tabs from "../../../components/tabs/index";
export default {
  props: {
    handlerType: { // 1 绑定手机，2 修改手机
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      updateShow: false, // 修改显示
      bindShow: false, // 绑定显示
      updatePhoneForm: { // 更换手机号码表单
        captcha: null,
        captchaKey0: null, // 手机验证码key
        captchaKey2: null, // 邮箱验证码key
        Password: null
      },
      bindPhoneForm: { // 绑定手机号码表单
        phone: null,
        captcha: null,
        captchaKey: null,
      },
      phoneRules: {
        phone: [{ validator: phoneVerify, trigger: "blur", }],
        captcha: [{ required: true, message: "请输入验证码", tarigger: "blur" }],
        Password: [{ required: true, message: "请输入当前密码", tarigger: "blur" }],
      },
      checkWay: true, // 验证方式 true 手机验证， false 邮箱验证
      disableNext: false, // 下一步按钮loading
      subLoading: false, // 提交按钮loading
      formData: {},
      tabsLabel: {
        "phone": "手机号验证",
        "isPassword": "密码验证",
        "mail": "邮箱验证"
      },
      tabsValue: {
        "phone": 0,
        "isPassword": 1,
        "mail": 2
      },
      tabs: [],
      str: ["phone", "isPassword", "mail"],
      labelObj: {
        "0": "当前手机号",
        "2": "邮箱"
      },
      tabsVal: null
    }
  },
  components: {
    Tabs
  },
  computed: {
    ...mapGetters(["allow", "phone", "mail", "timeRemaining", "captchaKey"])
  },
  watch: {
    handlerType: {
      handler(val) {
        if (val === 1) {
          this.bindShow = true
        } else if (val === 2) {
          this.updateShow = true;
          this.setTabs();
        } else {
          this.bindShow = false
          this.updateShow = false
          if (this.$refs['checkPhone']) {
            this.$refs['checkPhone'].resetFields()
          }
          if (this.$refs['bindPhone']) {
            this.$refs['bindPhone'].resetFields()
          }
        }
      }
    },
    captchaKey(val) { // 图形验证后设置相应的 captchaKey
      if (this.handlerType === 1) {
        this.bindPhoneForm.captchaKey = val
      } else if (this.handlerType === 2) {
        this.updatePhoneForm[`captchaKey${ this.tabsVal }`] = val
      }
    }
  },
  methods: {
    ...mapActions(["getCaptcha", "getUserInfo"]),
    // 取消
    cancel() {
      this.updatePhoneForm = { // 更换手机号码表单
        captcha: null,
        captchaKey0: null, // 手机验证码key
        captchaKey2: null, // 邮箱验证码key
        Password: null
      };
      this.$emit("update:handlerType", 0)
    },
    // 切换验证方式
    switchCheckWay() {
      // if (!this.mail) {
      //   this.$message({ type: "warning", message: "未绑定邮箱" })
      //   return
      // } else if (!this.phone) {
      //   this.$message({ type: "warning", message: "未绑定手机号" })
      //   return
      // }
      this.$store.commit("RESET_SMS")
      this.checkWay = !this.checkWay
    },
    // 获取短信验证码
    async sendSMS(captchaType) {
      let params
      if (this.checkWay) {
        params = {
          type: captchaType, // 1登录 2修改新手机号 3修改密码 4注册 5旧手机号
          captcha: "phone"
        }
        if (this.bindPhoneForm.phone) {
          params.phone = this.bindPhoneForm.phone
        }
      } else {
        params = {
          type: 14, // 11邮箱绑定，12邮箱更换前，13邮箱更换，14手机更换，15密码修改
          captcha: "mail"
        }
      }
      if (this.handlerType === 1) { // 绑定手机
        this.$refs['bindPhone'].validateField(('phone'), async (err) => {
          if (!err) {
            let { data } = await this.getCaptcha(params)
            if (data) {
              this.bindPhoneForm.captchaKey = data.captchaKey
            }
          }
        })
      } else { // 更换手机验证
        let { data } = await this.getCaptcha(params)
        if (data) {
          this.updatePhoneForm[`captchaKey${ this.tabsVal }`] = data.captchaKey
        }
      }
    },
    // 下一步验证手机号码
    checkPhone() {
      this.$refs[this.tabsVal !== 1 ? 'checkPhone' : 'Password_from'].validate(async valid => {
        if (valid) {
          let obj = {};
          // 手机、邮箱
          if (this.tabsVal !== 1) {
            if (!this.updatePhoneForm[`captchaKey${ this.tabsVal }`]) {
              this.$message.warning("请先获取验证码");
              return;
            }
            obj = {
              captcha: this.updatePhoneForm.captcha,
              captchaKey: this.updatePhoneForm[`captchaKey${ this.tabsVal }`]
            };
            if (this.checkWay) { // 手机验证
              obj.phone = this.phone;
            } else { // 邮箱验证
              obj.mail = this.mail;
            }
          } else {
            obj.password = this.updatePhoneForm.Password;
          }
          this.disableNext = true;
          let { data } = await checkPhone(obj).catch(() => {
            this.disableNext = false
          })
          if (data) {
            this.lastCaptchaKey = data
            this.$store.commit("RESET_SMS")
            this.$emit("update:handlerType", 1)
            this.checkWay = true;
          }
          this.disableNext = false
        }
      })
    },
    // 更换手机提交
    changePhoneSub() {
      this.$refs["bindPhone"].validate(async (valid) => {
        if (valid) {
          this.subLoading = true
          if (this.lastCaptchaKey) {
            let res = await updatePhone({ lastCaptchaKey: this.lastCaptchaKey, ...this.bindPhoneForm }).catch(() => { this.subLoading = false })
            if (res) {
              this.getUserInfo()
              this.$message.success("更换手机成功")
              this.$emit("update:handlerType", 0)
              this.subLoading = false
            }
          } else {
            let res = await bindPhone(this.bindPhoneForm).catch()
            if (res.code === 1) {
              this.getUserInfo()
              this.$message.success("绑定手机成功")
              this.$emit("update:handlerType", 0)
              this.subLoading = false
            }
          }
        }
      });
    },
    changeTabs(v) {
      this.tabsVal = v;
      if (v !== 1) {
        if (this.$refs['checkPhone']) {
          this.$refs['checkPhone'].resetFields();
          this.switchCheckWay();
        }
        if (v === 0) this.checkWay = true;
      } else {
        if (this.$refs['Password_from']) {
          this.$refs['Password_from'].resetFields();
        }
        this.switchCheckWay();
      }
    },
    setTabs() {
      this.tabs = [];
      for (let i = 0; i < this.str.length; i++) {
        const item = this.str[i];
        const val = this.userInfo[item];
        if (val) {
          this.tabs.push({
            value: this.tabsValue[item],
            label: this.tabsLabel[item],
          });
        }
      }
      if (this.tabs.length) {
        this.tabsVal = this.tabs[0].value;
        this.$nextTick(() => {
          this.$refs.TabsCom.selectStatus(this.tabs[0]);
        });
      }
    }
  }
}
</script>

<style lang="scss">
.bindPhoneDialog {
  .el-form-item {
    margin-bottom: 11px;
  }
  .clearMargenPadding {
    margin-bottom: 24px;
  }
  .new_dialogContent {
    margin-top: 18px;
    .el-tabs {
      .el-tabs__nav-wrap::after {
        height: 0;
      }
      .el-tabs__item {
        padding: 0 17px;
        &:last-child {
          padding-right: 0;
        }
      }
      .el-tabs__item.is-top:nth-child(2) {
        padding-left: 0;
      }
    }
    &_from {
      margin: 20px 0 22px;
      &_label {
        font-size: 14px;
        font-weight: 400;
        color: #202D40;
        line-height: 20px;
        margin-bottom: 14px;
      }
      .phoneORmail,
      .Password {
        &_val {
          width: 100%;
          height: 48px;
          background: #F4F5F6;
          border-radius: 4px;
          border: 1px solid #E8E8EB;
          line-height: 48px;
          padding-left: 16px;
          margin-bottom: 28px;
        }
      }
      &_el_form {
        .el-input__inner,
        .el-form-item__content {
          line-height: 48px;
        }
        .el-input__inner {
          height: 48px;
        }
      }
    }
  }
}
</style>